
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/travel-on-a-budget",
      function () {
        return require("private-next-pages/blog/travel-on-a-budget.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/travel-on-a-budget"])
      });
    }
  